export default {"src":"/_next/static/image/public/images/ic_right_pagination_arrow.27b5940ba16378312c611ba578071bc9.svg","height":15,"width":8};